// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textfield/Type.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField, view } from '@sail/ui';
export const Type = () => <view.div css={{
  layout: 'column',
  gap: 'medium'
}}>
    <TextField label="Text" type="text" />
    <TextField label="Password" type="password" />
    <TextField label="Search" type="search" />
    <TextField label="Number" type="number" />
  </view.div>;